import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import Notifications from '@kyvg/vue3-notification'
import { Skeletor } from 'vue-skeletor';

createApp(App).use(router).use(Notifications).component(Skeletor.name, Skeletor).mount('#app')
